import { render } from "./TheBikeTypeGenerals.vue?vue&type=template&id=6595976a"
import script from "./TheBikeTypeGenerals.vue?vue&type=script&lang=js"
export * from "./TheBikeTypeGenerals.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__